<script setup lang="ts">
import { IInternalToast } from '@/stores/toast.store';
import { Toast } from 'bootstrap';
import { onMounted, ref } from 'vue';

const props = defineProps<{ toast: IInternalToast }>();
const emit = defineEmits(['hidden']);

const toast$ = ref<Element | null>(null);

onMounted(() => {
  if (!toast$.value) {
    return;
  }
  const toast = new Toast(toast$.value);
  toast.show();
  toast$.value.addEventListener('hidden.bs.toast', () => {
    emit('hidden', props.toast.id);
  });
});
</script>

<template>
  <div
    ref="toast$"
    class="toast"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
    :data-bs-delay="toast.duration"
    :class="{
      'text-bg-primary': toast.type === 'primary',
      'text-bg-secondary': toast.type === 'secondary',
      'text-bg-success': toast.type === 'success',
      'text-bg-danger': toast.type === 'danger',
      'text-bg-warning': toast.type === 'warning',
      'text-bg-info': toast.type === 'info',
    }"
  >
    <div class="toast-header">
      <strong class="me-auto">{{ toast.title }}</strong>
      <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
    <div class="toast-body">
      {{ toast.message }}
    </div>
  </div>
</template>

<style scoped></style>
